/**
 * 获取滚动的元素
 * @param  {HTMLElement} element 子元素
 * @return {HTMLElement} 包含子元素的滚动元素
 */
export function getScrollEventTarget(element) {
  let currentNode = element

  while (currentNode &&
    currentNode.tagName !== 'HTML' &&
    currentNode.tagName !== 'BODY' &&
    currentNode.nodeType === 1
  ) {
    const { overflowY, overflowX } = window.getComputedStyle(currentNode)
    if ((overflowY === 'scroll' || overflowY === 'auto') && overflowX !== 'scroll') {
      return currentNode
    }
    currentNode = currentNode.parentNode
  }
  return window
}

/**
 * 获取元素当前滚动的距离
 * @param  {HTMLElement} element
 * @return {Number}
 */
export function getScrollTop(element) {
  if (element === window) {
    return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop)
  }
  return element.scrollTop
}

/**
 * 设置滚动高度
 * @param {HTMLElement} element
 * @param {Number} top
 */
export function setScrollTop(element, top) {
  const target = getScrollEventTarget(element)
  setTimeout(() => {
    target.scrollTop = top
  }, 50)
}

/**
 * 获取元素距离顶部高度(包括滚动的高度)
 * @param  {HTMLElement} element
 * @return {Number}
 * 参考 https://developer.mozilla.org/zh-CN/docs/Web/API/Element/getBoundingClientRect
 */
export function getElementTop(element) {
  if (element === window) {
    return getScrollTop(window)
  }
  return element.getBoundingClientRect().top + getScrollTop(window)
}
